import './App.css';
import Index from './components/dashboard/Index';
import GetCoupon from './components/GetCoupon';
import './remix-icon/remixicon.css';
import Referal from './components/dashboard/Referal';
import Mine from './components/dashboard/Mine';
import Notification from './components/dashboard/Notification';
import Upgrade from './components/dashboard/Upgrade';
import Login from './components/dashboard/Login';
import Profile from './components/dashboard/Profile'
import {BrowserRouter ,Routes,Route} from 'react-router-dom';
import {useState,useEffect,createContext} from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Admin from './components/admin/Index';
import Main from './components/admin/Main';
import Process from './components/admin/Process';
import GetAccount from './components/dashboard/GetAccount';
import Withdrawal from './components/dashboard/Withdrawal';
import Lost from './components/404';
import {useDispatch} from 'react-redux'
import { setDataKey } from './actions/actionMethod';
import Verify from './components/Verify';
import Marketplace from './components/dashboard/Marketplace';
import Home from './components/main-website/Home';
import HowItWorks from './components/main-website/HowItWorks';
import Packages from './components/main-website/Packages';
import BuyCouponCode from './components/main-website/BuyCouponCode';
import Menu from './components/main-website/Menu';
import './styles/utility.css'
import Ads from "./components/admin/ads";
import ViewAd from './components/ViewAd'; 
function App() {
  const auth = getAuth();
  const dispatch = useDispatch();
  const [signedIn,setSignedIn]=useState(true)
  useEffect(()=>{
  const subscribe =  onAuthStateChanged(auth, (user) => {
      user ? setSignedIn(true) : setSignedIn(false)
      if(user){
         dispatch(setDataKey(auth.currentUser.email))
      }
    })
   return ()=> subscribe();

  },[])
 
  return signedIn ? (
    <div className="App">
    <BrowserRouter>
      <Routes>
      <Route exact path="/" element={<Index />}/>
          <Route exact path="/dashboard/" element={<Index />} >
          </Route> 
          <Route exact path="/dashboard/coupon" element={<GetCoupon />} >
          </Route> 
          <Route exact path="/dashboard/referral" element={<Referal />} >
          </Route> 
          <Route exact path="/dashboard/mine" element={<Mine />} >
          </Route> 
          <Route exact path="/dashboard/notifications" element={<Notification />} >
          </Route> 
          <Route exact path="/dashboard/upgrade" element={<Upgrade />}>
          </Route> 
          <Route exact path="/dashboard/profile" element={<Profile />}>
          </Route>
          <Route exact path="/admin/" element={<Admin />}>
          </Route>
           <Route exact path="/admin/main" element={<Main />}>
          </Route>
           <Route exact path="/admin/process" element={<Process />}>
          </Route>
           <Route exact path="/dashboard/account" element={<GetAccount />}>
          </Route>
           <Route exact path="/dashboard/withdraw" element={<Withdrawal />}>
          </Route>
           <Route exact path="/dashboard/marketplace" element={<Marketplace />}>
          </Route>
          <Route exact path="/buy-coupon-code" element={<BuyCouponCode />}>
            </Route> 
          <Route exact path="/verify" element={<Verify />} >
            </Route>
          <Route exact path="/login" element={<Login />} >
            </Route>
            <Route exact path="/admin/ads" element={<Ads />} ></Route>
            <Route exact path="/dashboard/marketplace/resource" element={<ViewAd user={signedIn} />} ></Route>
           <Route exact path="*" element={<Lost />}>
          </Route>
      </Routes>
    </BrowserRouter>  
    </div>
  ) : 
  <div className="App">
    <BrowserRouter>
      <Routes>
      <Route exact path="/" element={<Home />}/> 
      <Route exact path="/menu" element={<Menu />}/> 
      <Route exact path="/packages" element={<Packages />}/> 
      <Route exact path="/buy-coupon-code" element={<BuyCouponCode />}/> 
      <Route exact path="/how-it-works" element={<HowItWorks />}/> 
        <Route exact path="/login" element={<Login />}/> 
         <Route exact path="/admin/" element={<Admin />}/> 
         <Route exact path="/admin/main" element={<Main />}/>
          <Route exact path="/admin/process" element={<Process />}/>
          <Route exact path="/verify" element={<Verify />} />
          <Route exact path="dashboard/marketplace/resource" element={<ViewAd user={signedIn} />} />
          <Route exact path="*" element={<Lost />}/>
         
         
      </Routes>
    </BrowserRouter>  
    </div>
}

export default App;
